export default function calculateFees(value, setTotalFees) {
  const eventGivesFee = value * 0.03;
  const totalFees = value < 100000 ? eventGivesFee : 3000;
  if (isNaN(totalFees)) {
    setTotalFees(0);
  } else {
    setTotalFees(totalFees);
  }
}
